var $ = require("jquery");
$(document).foundation();

//header

/*
		By Osvaldas Valutis, www.osvaldas.info
		Available for use under the MIT License
	*/
(function(document, window, index) {
    "use strict";

    var elSelector = ".app-header",
        elClassHidden = "--hidden",
        elClassNarrow = "--narrow",
        elNarrowOffset = 50,
        throttleTimeout = 500,
        element = document.querySelector(elSelector);

    if (!element) return true;

    var dHeight = 0,
        wHeight = 0,
        wScrollCurrent = 0,
        wScrollBefore = 0,
        wScrollDiff = 0,
        hasElementClass = function(element, className) {
            return element.classList
                ? element.classList.contains(className)
                : new RegExp("(^| )" + className + "( |$)", "gi").test(
                      element.className
                  );
        },
        addElementClass = function(element, className) {
            element.classList
                ? element.classList.add(className)
                : (element.className += " " + className);
        },
        removeElementClass = function(element, className) {
            element.classList
                ? element.classList.remove(className)
                : (element.className = element.className.replace(
                      new RegExp(
                          "(^|\\b)" +
                              className.split(" ").join("|") +
                              "(\\b|$)",
                          "gi"
                      ),
                      " "
                  ));
        },
        throttle = function(delay, fn) {
            var last, deferTimer;
            return function() {
                var context = this,
                    args = arguments,
                    now = +new Date();
                if (last && now < last + delay) {
                    clearTimeout(deferTimer);
                    deferTimer = setTimeout(function() {
                        last = now;
                        fn.apply(context, args);
                    }, delay);
                } else {
                    last = now;
                    fn.apply(context, args);
                }
            };
        };

    window.addEventListener(
        "scroll",
        throttle(throttleTimeout, function() {
            dHeight = document.body.offsetHeight;
            wHeight = window.innerHeight;
            wScrollCurrent = window.pageYOffset;
            wScrollDiff = wScrollBefore - wScrollCurrent;

            if (wScrollCurrent > elNarrowOffset) {
                // toggles "narrow" classname
                if (!hasElementClass(element, elClassNarrow))
                    addElementClass(element, elClassNarrow);
            } else removeElementClass(element, elClassNarrow);

            if (wScrollCurrent <= 0)
                // scrolled to the very top; element sticks to the top
                removeElementClass(element, elClassHidden);
            else if (wScrollDiff > 0 && hasElementClass(element, elClassHidden))
                // scrolled up; element slides in
                removeElementClass(element, elClassHidden);
            else if (wScrollDiff < 0) {
                // scrolled down
                if (
                    wScrollCurrent + wHeight >= dHeight &&
                    hasElementClass(element, elClassHidden)
                ) {
                    //removeElementClass(element, elClassHidden);
                }
                // scrolled to the very bottom; element slides in

                // scrolled down; element slides out
                else {
                    addElementClass(element, elClassHidden);
                }
            }

            wScrollBefore = wScrollCurrent;
        })
    );
})(document, window, 0);

//search

$(".search").on("keyup", function(e) {
    $(".search-results")
        .children(".items")
        .html("");
});

$(".SELECT_MENU_ITEM").on({
    mouseenter: function() {
        var width = $('.SELECT_GRID_WIDTH').width()
        $(this).width(width)
        $(".SELECT_SEARCH_MOBILE_OVERLAY").show();
    },
    mouseleave: function() {
        $(this).width('12rem')
    }
});


$(".SELECT_MENU").on({
    mouseenter: function() {
        $(".SELECT_SEARCH_MOBILE_OVERLAY").show();
        $(".SELECT_SEARCH_INPUT").css({"z-index": 0})
    },
    mouseleave: function() {
        $(".SELECT_SEARCH_MOBILE_OVERLAY").hide();
        $(".SELECT_SEARCH_INPUT").css({"z-index": 2000})
    }
});

$(".search").on(
    "keyup",
    delay(function(e) {
        $(".search-results").show();
        //$(".search-results").addClass("loading");

        e.preventDefault();
        $value = $(this).val();

        $.ajax({
            type: "post",
            url: "/search",
            dataType: "json",
            data: { search: $value },
            beforeSend: function() {
                if ($value.length > 0) {
                    $(".search-results").addClass("loading");
                    $(".search-results").show();
                }
                $(".SELECT_SEARCH_MOBILE_OVERLAY").show();
                $(".SELECT_MENU").css({"z-index": 0})
            },
            success: function(data) {
                $(".search-results").removeClass("loading");

                if (data.length === 0) {
                    $(".search-results").hide();
                }

                $(".search-results")
                    .children(".items")
                    .html("");

                const filteredData = data.filter(item => {
                    console.log('filtering');
                    if (item.type !== "products") {
                        return true;
                    }

                    const matchingLandingPage = data.find(landingPage =>
                        landingPage.type === "landing_pages" &&
                        landingPage.searchable.product_id === item.searchable.id &&
                        landingPage.searchable.name === item.searchable.name
                    );

                    return !matchingLandingPage;
                });

                filteredData.forEach(e => {
                    if(e.type === "products") {
                        $(".search-results").children(".items").append(`
                            <a href="/bestellen/${e.searchable.slug}">
                                <div class="item">
                                    <img src="images/products/${e.searchable.image}" alt="${e.searchable.name}">
                                    <div class="content">
                                        <h6>${e.searchable.name}</h6>
                                        <p>${e.searchable.description}</p>
                                    </div>
                                </div>
                            </a>
                        `);
                    } else if(e.type === "pages") {
                        $(".search-results").children(".items").append(`
                            <a href="/page/${e.searchable.slug}">
                                <div class="item">
                                    <div class="content">
                                        <h6>${e.searchable.name}</h6>
                                        <p>Algemene informatie</p>
                                    </div>
                                </div>
                            </a>
                        `);
                    } else {
                        $(".search-results").children(".items").append(`
                            <a href="/${e.searchable.slug}">
                                <div class="item">
                                    <div class="content">
                                        <h6>${e.searchable.name}</h6>
                                    </div>
                                </div>
                            </a>
                        `);
                    }
                });

                // $('.search-results').html(data[0].name);
            },
            error: function(xhr) {
                if(xhr.status === 419){
                    location.reload();
                }
                $(".search-results").removeClass("loading");
                $(".search-results").hide();
                throw xhr.responseJSON.errors;
            }
        });
    }, 500)
);

$.ajaxSetup({
    headers: {
        "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content")
    }
});
function delay(callback, ms) {
    var timer = 0;
    return function() {
        var context = this,
            args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function() {
            callback.apply(context, args);
        }, ms || 0);
    };
}
$("#switchdelivery").change(function() {
    // this will contain a reference to the checkbox
    if (this.checked) {
        $(".hide-delivery").show();
    } else {
        $(".hide-delivery").hide();
    }
});

$("#invoiceModal").on("click", ".addplus", function() {
    $(".addaddress").show();
});

const heightHeader = $(".app-header").height();
//const heightSubHeader = $(".app-fixed-menu").height();
//const totalHeightHeaders = heightHeader + heightSubHeader;
$(".placeholder-fixed-header").height(heightHeader);

$(".ACTION_BTWNUMMER").on("click", function(e) {
    e.preventDefault();
    const btwnummer = $(".btwnummer").val();
    const countrycode = $(".countrycode").val();

    $.ajax({
        type: "post",
        url: "/mijn-account/btwnummer/",
        dataType: "json",
        data: { btwnummer: btwnummer, countrycode: countrycode },
        success: function(data) {
            $(".btwcheck").html("<div class=\"callout success \">" + data.msg + "</div>")
        },
        error: function(xhr) {

                $(".btwcheck").html("<div class=\"callout alert \">" + xhr.responseJSON.msg + "</div>")

        }
    });
});

$(".ACTION_SHOW_MOBILE_MENU").click(function() {
    $(".SELECT_MOBILE_MENU").addClass("show");
    $(".SELECT_MOBILE_OVERLAY").show();
    stopScrolling();
});

$(".ACTION_HIDE_MOBILE_MENU").click(function() {
    $(".SELECT_MOBILE_MENU").removeClass("show");
    $(".SELECT_MOBILE_OVERLAY").hide();
    enableScrolling();
});

function stopScrolling() {
    $("body").addClass("stop-scrolling");
    $("body").bind("touchmove", function(e) {
        e.preventDefault();
    });
}

function enableScrolling() {
    $("body").removeClass("stop-scrolling");
    $("body").unbind("touchmove");
}

$(".ACTION_NEWSLETTER_SIGNUP").on("click", function(e) {
    e.preventDefault();

    const email = $("#newsletter").val();

    $.ajax({
        type: "post",
        url: "/newslettersignup",
        dataType: "json",
        data: { email: email },
        beforeSend: function() {
            $(".newslettersuccess").html("");
            $(".newslettererror").html("");
        },
        success: function(data) {
            $(".SELECT_NEWSLETTER_STATUS").removeClass("hide");
            $(".SELECT_NEWSLETTER_CALLOUT_SUCCESS").removeClass("hide");
            $(".SELECT_NEWSLETTER_ERROR_CONTENT_SUCCESS").html(data.msg);
        },
        error: function(xhr) {
            $(".SELECT_NEWSLETTER_STATUS").removeClass("hide");
            $(".SELECT_NEWSLETTER_CALLOUT_ALERT").removeClass("hide");
            $(".SELECT_NEWSLETTER_ERROR_CONTENT_ALERT").html(
                xhr.responseJSON.errors
            );
            throw xhr.responseJSON.errors;
        }
    });
});

$(".thumbsup").on("click", function(e) {
    e.preventDefault();

    $.ajax({
        type: "post",
        url: "/customerexperience",
        dataType: "json",
        data: { experience: 1 },
        beforeSend: function() {},
        success: function(data) {
            $(".thumbsup").remove();
            $(".thumbsdown").remove();
            $(".ervaring").html(
                '<div class="grid-x grid-padding-x"><div class="cell large-6"><p>Hartelijk dank voor je reactie!</p></div></div>'
            );
        },
        error: function(xhr) {
            $(".product-title").append(xhr.responseJSON.errors);
            throw xhr.responseJSON.errors;
        }
    });
});

$(".thumbsdown").on("click", function(e) {
    e.preventDefault();

    $.ajax({
        type: "post",
        url: "/customerexperience",
        dataType: "json",
        data: { experience: 0 },
        beforeSend: function() {},
        success: function(data) {
            $(".thumbsup").remove();
            $(".thumbsdown").remove();
            $(".ervaring").html(
                '<div class="grid-x grid-padding-x"><div class="cell large-6"><p>Hartelijk dank voor je reactie!</p></div></div>'
            );
        },
        error: function(xhr) {
            $(".product-title").append(xhr.responseJSON.errors);
            throw xhr.responseJSON.errors;
        }
    });
});

$(".ACTION_HIDE_SEARCH_MOBILE_MENU").click(function() {
    $(this).hide();
    $(".SELECT_MENU").css({"z-index": 2000})
    $(".SELECT_SEARCH_INPUT")
        .find(".search-results")
        .hide();
    $(".SELECT_SEARCH_INPUT")
        .find("input")
        .val("");
});

$(".acceptquote").on("submit", function(e) {
    $(".submitquote").prop("disabled", true);
});

$.datepicker.setDefaults( $.datepicker.regional[ "nl" ] );
$( "#deliverydate" ).datepicker();

$('.ACTION_EDIT_ADDRESS').on('click', function (e) {
    e.preventDefault();

	$('#editAddress').foundation('open');

    let id = $(this).data('id');

    $('.SELECT_EDIT_ADDRESS').load('/mijn-account/adressen/edit/'+id, function (edit) {

    });
});

$('.ACTION_REMOVE_ADDRESS').on('click', function (e) {
    e.preventDefault();
	$(this).siblings('form').submit()
});

$('.ORDERUPLOAD').on('submit',function(e){
    e.preventDefault();
    const id = $(this).data('id');
    const files = $('#file')[0].files;

    for (var i = 0, f; f = files[i]; i++) {

        var fd = new FormData();
        fd.append("uploadFile[]", files[i]);

        $.ajax({
            type: "post",
            url: "/mijn-account/order/"+id+"/fileupload",
            data: fd,
            processData: false,
            contentType: false,
            beforeSend: function(e) {
                $('.orderupload').addClass("loading");
                $('.loader').show();
            },
            success: function(data) {
                $('.orderupload').removeClass("loading");
                $('.loader').hide();
                window.location = "/mijn-account/order/"+id;
            },
            error: function(jqXHR, textStatus, errorMessage) {
                $('.orderupload').removeClass("loading");
                $('.loader').hide();
                $('.result').html(jqXHR.responseJSON.errors[0].message[0]);
            }
        });
    }
});
$('.quoteform').on('submit',function(e){
    $('.loader').show();
    $('.quotesubmit').attr("disabled",true);
});
